
import { Vue } from "vue-class-component";

export default class BalanceNotification extends Vue {}
